<ion-button size="small" fill="clear" aria-label="toggle privacy" (click)="toggleShowNumbers()">
  <ion-label class="ion-hide-lg-down">{{ showNumbers ? "Enable" : "Disable" }} Privacy</ion-label>
  <ion-icon slot="end" name="{{ showNumbers ? 'eye-off-outline' : 'eye-outline' }}"></ion-icon>
</ion-button>
